type MeSubBackHandler = () => unknown | Promise<unknown>

/** 回调不可进 useState（SSR payload 无法序列化函数） */
const meSubOnBack = shallowRef<MeSubBackHandler | null>(null)

/**
 * 我的二级页：注册 AppBar 标题与返回
 */
export function useMeSubPage(opts: {
  title: () => string
  onBack: MeSubBackHandler
}) {
  const { title } = useMeSubNav()

  meSubOnBack.value = opts.onBack
  watchEffect(() => {
    title.value = opts.title()
  })

  onBeforeUnmount(() => {
    // 仅清理自身注册，避免二级路由切换时后卸载页冲掉新页
    if (meSubOnBack.value !== opts.onBack) return
    title.value = ''
    meSubOnBack.value = null
  })
}

export const useMeSubNav = () => {
  const title = useState<string>('meSubNavTitle', () => '')

  const back = () => {
    if (meSubOnBack.value) {
      meSubOnBack.value()
      return true
    }
    return false
  }

  return { title, onBack: meSubOnBack, back }
}
